export default __webpack_public_path__ + "static/media/adobe-xd-logo.a5b3c95b.png";